<button id="decline-offer-button" nbButton size="medium" outline status="primary" (click)="showDeclineOfferDialog(dialog)" [disabled]="disabled">
	{{ 'common.decline' | translate }}
</button>

<ng-template #dialog let-data let-declineDialog="dialogRef">
	<form [formGroup]="declineOrderForm">
		<nb-card class="decline-order-modal">
			<nb-card-body>
				<div style="text-align: left;">
					<h2>{{ 'order-decline-dialog.title' | translate }}</h2>
					<div id="declined-order-info">{{ 'order-decline-dialog.permanent-delete-notice' | translate }}</div>
				</div>
				<div>
					<label for="declining-reason-input">{{ 'order-decline-dialog.decline-reason-question' | translate }}</label>
					<textarea id="declining-reason-input" nbInput fullWidth name="decliningReason" formControlName="decliningReason"
							  placeholder="{{'order-decline-dialog.decline-reason-placeholder' | translate}}"></textarea>
				</div>
				@if (!(declineOrderForm.controls['decliningReason'].valid || isDeclineReasonControlPristine)) {
					<div class="validation-message"
					>{{ getDeclineFormErrors() }}
					</div>
				}
			</nb-card-body>
			<nb-card-footer>
				<button id="cancel-decline-order-button" nbButton outline status="danger" (click)="declineDialog.close(); declineOrderForm.reset()">{{ 'common.cancel' | translate }}</button>
				<button id="confirm-decline-order-button" nbButton status="danger" (click)="declineOffer(declineDialog)"
						[disabled]="!(declineOrderForm.valid || isFormPristine())">
					{{ 'order-decline-dialog.button-text' | translate }}
				</button>
			</nb-card-footer>
		</nb-card>
	</form>
</ng-template>
